import { render, staticRenderFns } from "./StandardListDetail.vue?vue&type=template&id=30828e98"
import script from "./StandardListDetail.vue?vue&type=script&lang=js"
export * from "./StandardListDetail.vue?vue&type=script&lang=js"
import style0 from "./StandardListDetail.vue?vue&type=style&index=0&id=30828e98&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports